import EventNotificationSubscriberImpl from './event-notification-subscriber.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
const UIView = MojitoCore.Presentation.UIView;

/**
 * EventNotificationsSubscriber component. Used to subscribe to event push notifications. Typically used on event coupons and event details pages.
 *
 * @class EventNotificationSubscriber
 * @memberof Mojito.Modules.EventNotifications
 */

/**
 * EventNotificationSubscriber prop types.
 *
 * @property {string} eventId - Event id.
 *
 * @memberof Mojito.Modules.EventNotifications.EventNotificationSubscriber
 */
const propTypes = {
    eventId: PropTypes.string.isRequired,
};

export default UIView('EventNotificationSubscriber', EventNotificationSubscriberImpl, propTypes);
